import filter from '@app/store/modules/ui/shared/lotto/filter/filterIndex.ts';
import { routeNames } from '@src/app/router/constants';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import betSlip from './betSlip/index';

export { default as subscriptions } from './subscriptions';

export default {
    state,
    mutations,
    getters,
    actions,
    modules: {
        betSlip,
        filter: filter({
            baseLotteryRoute: routeNames.lotteryLanding,
            lotteryFilterRoute: routeNames.lotteryGame,
            lotterySystemRoute: routeNames.lotterySystem,
            eventsGetter: 'data/lottoOffer/lottoEvents',
            selectedEventGetter: 'ui/lotto/expandedEventId',
        }),
    },
    namespaced: true,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/lottoPageIndex.ts